import React from 'react';

interface SuccessIconProps {
  className?: string;
  size?: number;
}

const SuccessIcon: React.FC<SuccessIconProps> = ({ className = '', size = 18 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.83342 12.8332L13.7084 6.95817L12.5417 5.7915L7.83342 10.4998L5.45842 8.12484L4.29175 9.2915L7.83342 12.8332ZM9.00008 17.3332C7.8473 17.3332 6.76397 17.1144 5.75008 16.6769C4.73619 16.2394 3.85425 15.6457 3.10425 14.8957C2.35425 14.1457 1.7605 13.2637 1.323 12.2498C0.885498 11.2359 0.666748 10.1526 0.666748 8.99984C0.666748 7.84706 0.885498 6.76373 1.323 5.74984C1.7605 4.73595 2.35425 3.854 3.10425 3.104C3.85425 2.354 4.73619 1.76025 5.75008 1.32275C6.76397 0.885254 7.8473 0.666504 9.00008 0.666504C10.1529 0.666504 11.2362 0.885254 12.2501 1.32275C13.264 1.76025 14.1459 2.354 14.8959 3.104C15.6459 3.854 16.2397 4.73595 16.6772 5.74984C17.1147 6.76373 17.3334 7.84706 17.3334 8.99984C17.3334 10.1526 17.1147 11.2359 16.6772 12.2498C16.2397 13.2637 15.6459 14.1457 14.8959 14.8957C14.1459 15.6457 13.264 16.2394 12.2501 16.6769C11.2362 17.1144 10.1529 17.3332 9.00008 17.3332Z"
        fill="#2ABF80"
      />
    </svg>
  );
};

export default SuccessIcon;
